import { MoreHorizontal } from 'lucide-react';

export function ActionMenu({ actions = [], label = 'Open actions' }) {
  const visible = actions.filter((action) => !action.hidden);
  if (!visible.length) return null;

  return <details className="action-menu group relative" onClick={(event) => event.stopPropagation()}>
    <summary aria-label={label} className="grid size-8 cursor-pointer list-none place-items-center border border-white/10 bg-white/[.025] text-slate-500 transition hover:border-cyan-300/30 hover:text-cyan-100">
      <MoreHorizontal size={15}/>
    </summary>
    <div className="absolute right-0 top-[calc(100%+6px)] z-50 min-w-44 border border-white/10 bg-[#07101a]/98 p-1.5 shadow-[0_18px_60px_rgba(0,0,0,.55)] backdrop-blur-xl">
      {visible.map((action) => {
        const Icon = action.icon;
        return <button
          key={action.label}
          type="button"
          disabled={action.disabled}
          onClick={(event) => {
            event.preventDefault();
            event.currentTarget.closest('details')?.removeAttribute('open');
            action.onClick?.();
          }}
          className={`flex h-9 w-full items-center gap-2.5 px-2.5 text-left text-[11px] font-semibold transition disabled:opacity-35 ${action.danger ? 'text-rose-300 hover:bg-rose-400/[.08]' : 'text-slate-300 hover:bg-white/[.045] hover:text-cyan-100'}`}
        >
          {Icon ? <Icon size={13}/> : <span className="size-[13px]"/>}
          <span className="min-w-0 flex-1 truncate">{action.label}</span>
        </button>;
      })}
    </div>
  </details>;
}
